import { render, staticRenderFns } from "./onaybelgesi.vue?vue&type=template&id=11cebce4&"
import script from "./onaybelgesi.vue?vue&type=script&lang=js&"
export * from "./onaybelgesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports